import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../utils/service";

export const fetchResumeDetails = async (
  personalDetails: any,
  model: string
) => {
  const url = `${urls.fetchResumeDetails}/${model}`;
  try {
    const callParams = await getCallParams("POST", personalDetails);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
